/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RestResponse} from '../model';
import {environment} from '../../environments/environment';
import {ApiHeaders} from './headers';
import { ReportDelay } from '../model/report';

@Injectable()
export class ReportDelayProvider {

  constructor(
    private http: HttpClient
  ) {}

  startDelay(id: string, notify: boolean, delay: string,  reason: string, notes?: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/delay/start`,
        {
          REASON: reason ? reason : '',
          NOTES: notes ? notes: '',
          DELAY_TYPE: delay,
          NOTIFY_CLIENT: notify
        }, ApiHeaders.getOptions());
  }

  stopDelay(id: string, notify: boolean, delay: string,  reason: string, notes?: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/delay/stop`,
        {
          REASON: reason ? reason : '',
          NOTES: notes ? notes: '',
          DELAY_TYPE: '',
          NOTIFY_CLIENT: notify
        }, ApiHeaders.getOptions());
  }

  saveDelay(id: string, did: string, delay: ReportDelay): Observable<RestResponse> {
    return this.http
      .put<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/delay/${did}`, delay, ApiHeaders.getOptions());
  }

}
